import { makeStyles } from "@mui/styles";

export const useRecordingViewerStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f5f7fb",
  },
  header: {
    backgroundColor: "#ffffff !important",
    borderBottom: "1px solid #e5e7eb",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1) !important",
    flexShrink: 0,
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    width: "100%",
  },
  pageInner: {
    maxWidth: 1200,
    margin: "0 auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    paddingBlock: 24,
    paddingInline: 16,
    flex: 1,
    overflow: "hidden",
  },
  pageTitle: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#0f172a",
  },
  pageMeta: {
    color: "#475569",
  },
  playerWrapper: {
    border: "none",
    borderRadius: 12,
    overflow: "hidden",
    width: "100%",
    height: "100%",
  },
  playerCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(15, 23, 42, 0.06)",
    overflow: "hidden",
    flex: 1,
    display: "flex",
    minHeight: 0,
  },
  playerInner: {
    padding: 16,
    display: "flex",
    flex: 1,
    minHeight: 0,
    '@media (max-width:900px)': {
      padding: 12,
    },
  },
  errorWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: 400,
  },
  errorCard: {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    paddingInline: 24,
    paddingBlock: 32,
    maxWidth: 520,
    textAlign: "center" as const,
    boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
  },
  errorImage: {
    width: 140,
    height: "auto",
    marginBottom: 12,
    borderRadius: 8,
  },
  emptyWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    height: "100%",
    minHeight: 400,
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: 0,
  },
});
